import { keyframes } from '@tanium/react-emotion-9';

const shimmer = keyframes({
  to: {
    transform: 'translateX(100%)',
  },
});

export default `${shimmer} 0.8s linear infinite`;
